

































































import {
  computed,
  defineComponent,
  onMounted,
  toRefs
} from '~/utils/nuxt3-migration'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { useAnalytics } from '~/compositions/analytics'
import { defineComponentTranslations } from '~/utils/i18n'
import { CategoryId } from '~/models/category/types'
import { useI18n } from '~/compositions/i18n'
import { ciCheck } from '~/icons/source/solid/check'

export default defineComponent({
  components: {
    CImg,
    CCard
  },
  props: {
    classified: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { classified } = toRefs(props)
    const analytics = useAnalytics()
    const { t } = useI18n()

    onMounted(() => {
      analytics.recordEvent({
        namespace: 'n_hellas_direct_banner',
        action: 'banner_appeared'
      })
    })

    const insuranceData = computed(() => {
      const data = {
        title: t('vehicle_insurance'),
        description: t('car_description'),
        subtitle: t('debit_instalments'),
        link:
          'https://www.hellasdirect.gr/asfaleia-autokinitou?utm_source=cargr&utm_medium=widget&utm_campaign=carinsurance',
        perks: [
          t('benefit', { percent: 40 }),
          t('accident'),
          t('compensation'),
          t('installments')
        ],
        category: 'car'
      }
      if (categoryIdsInclude(CategoryId.COMMERCIAL)) {
        data.description = t('vehicle_description')
      } else if (categoryIdsInclude(CategoryId.BIKES)) {
        data.description = t('bike_description')
        data.link =
          'https://www.hellasdirect.gr/motorcycle/wizard/your-motorcycle?utm_source=cargr&utm_medium=widget&utm_campaign=bikeinsurance'
        data.perks = [
          t('benefit', { percent: 30 }),
          t('accident'),
          t('compensation'),
          t('duration')
        ]
        data.subtitle = ''
        data.category = 'bike'
      } else if (categoryIdsInclude(CategoryId.PLOT)) {
        data.title = t('home_insurance')
        data.description = t('home_description')
        data.link =
          'https://www.hellasdirect.gr/property/wizard?utm_source=cargr&utm_medium=widget&utm_campaign=homeinsurance'
        data.perks = [
          t('benefit', { percent: 40 }),
          t('earthquake'),
          t('discount'),
          t('compensation')
        ]
        data.subtitle = ''
        data.category = 'home'
      }
      return data
    })

    function categoryIdsInclude(id: number) {
      return classified.value.category_ids?.includes(id)
    }

    function getOfferClick(category: string) {
      analytics.recordEvent({
        namespace: 'n_hellas_direct_banner_button',
        action: 'click',
        label: category
      })
    }

    return {
      insuranceData,
      ciCheck,
      getOfferClick
    }
  },

  i18n: defineComponentTranslations({
    car_description: {
      en: '<span>Car</span> insurance from <span>6€/month</span>',
      el: 'Ασφάλεια <span>αυτοκινήτου</span> από <span>6€/μήνα</span>'
    },
    vehicle_description: {
      en: '<span>Vehicle</span> insurance from <span>6€/month</span>',
      el: 'Ασφάλεια <span>οχήματος</span> από <span>6€/μήνα</span>'
    },
    home_description: {
      en: '<span>Home</span> insurance from <span>0.27€/day</span>',
      el: 'Ασφάλεια <span>σπιτιού</span> από <span>0,27€/μέρα</span>'
    },
    bike_description: {
      en: '<span>Motorcycle</span> insurance from <span>3.5€/month</span>',
      el: 'Ασφάλεια <span>μοτοσυκλέτας</span> από <span>3,5€/μήνα</span>'
    },
    from_hellas_direct: {
      en: 'From',
      el: 'By'
    },
    benefit: {
      en: 'Up to <strong>{percent}%</strong> benefit on annual policies',
      el: 'Όφελος έως και <strong>{percent}%</strong> στο ετήσιο'
    },
    accident: {
      en: '<strong>24/7</strong> emergency line',
      el: 'Εξυπηρέτηση για ατύχημα <strong>24/7</strong>'
    },
    compensation: {
      en: '<strong>Lightning-fast</strong> claims settlement',
      el: '<strong>Αστραπιαία</strong> αποζημίωση'
    },
    installments: {
      en: 'Instalments without credit card',
      el: 'Δόσεις χωρίς πιστωτική'
    },
    duration: {
      en: 'Duration from 30 to 365 days',
      el: 'Διάρκεια από 30 έως 365 μερες'
    },
    earthquake: {
      en: 'Earthquake and fire cover',
      el: 'Κάλυψη για σεισμό και πυρκαγιά'
    },
    discount: {
      en: 'ENFIA discount up to 20%',
      el: 'Έκπτωση ΕΝΦΙΑ έως 20%'
    },
    debit_instalments: {
      en: 'In debit card instalments.',
      el: 'Σε δόσεις με χρεωστική.'
    },
    get_offer: {
      en: 'Get a quote',
      el: 'Πάρε προσφορά'
    }
  })
})
